import { Container, Grid, styled } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

export const Wrapper = styled(Container)``
export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.align};

  &.MuiGrid-item {
    margin: ${props => props.margin};
  }
`
export const ProviderButton = styled('button')`
  position: relative;
  padding: 0;
  margin: 0;
  background: transparent;
  text-align: left;
  outline: none;
  border: 0;
  cursor: pointer;
  text-decoration: underline;
  color: ${props => props.theme.palette.brand.black1};
`
export const Image = styled('img')`
  pointer-events: none;
  user-select: none;
  margin: ${props => props.margin};
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary}

  &:hover{
    color: ${props => props.theme.palette.blue[35]}
  }

  &:visited{
    color: ${props => props.theme.palette.brand.primary}
  }
`
export const InlineLabel = styled('div')`
  color: ${props => props.theme.palette.brand.primary};
`
export const Info = styled(InfoIcon)`
  position: relative;
  top: 2px;
  margin-left: 5px;
  width: 16px;
  height: 16px;
  color: ${props => props.theme.palette.brand.black1};

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`
